var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatavisualization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.728,
    height: 24.22,
    viewBox: "0 0 26.728 24.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.349 -4.413)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.349 4.413)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.297 5.265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.573,23.411a3.071,3.071,0,0,0,3.07-3.066,3.029,3.029,0,0,0-.767-2.019h0a1.07,1.07,0,0,0-1.06-.949,1.058,1.058,0,0,0-.3.049v0a2.967,2.967,0,0,0-.939-.149,3.068,3.068,0,0,0,0,6.135Zm1.9-4.961a.663.663,0,1,1-.663-.663A.664.664,0,0,1,31.477,18.45Zm-1.9-.642a2.543,2.543,0,0,1,.365.028,1.069,1.069,0,1,0,1.785,1.176,2.5,2.5,0,0,1,.387,1.333,2.536,2.536,0,1,1-2.538-2.538Z",
    transform: "translate(-26.507 -17.276)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.759,31.9H6.274a.409.409,0,0,0,.409-.409V26.975a.409.409,0,0,0-.409-.409H4.221v-.538a1.548,1.548,0,0,1,1.547-1.547h8.741v2.084H12.456a.409.409,0,0,0-.409.409V31.49a.409.409,0,0,0,.409.409h4.515a.409.409,0,0,0,.409-.409V26.975a.409.409,0,0,0-.409-.409H14.918V24.481h8.741a1.548,1.548,0,0,1,1.547,1.547v.538H23.153a.409.409,0,0,0-.409.409V31.49a.409.409,0,0,0,.409.409h4.515a.409.409,0,0,0,.409-.409V26.975a.409.409,0,0,0-.409-.409H25.615v-.538a1.958,1.958,0,0,0-1.956-1.956H14.918V22.078c6.473-.114,11.588-5.553,11.8-5.787a.409.409,0,0,0,0-.556C26.5,15.5,21.283,9.943,14.713,9.943S2.923,15.5,2.7,15.735a.409.409,0,0,0,0,.556c.217.234,5.332,5.673,11.8,5.787v1.994H5.768a1.958,1.958,0,0,0-1.956,1.956v.538H1.759a.409.409,0,0,0-.409.409V31.49A.409.409,0,0,0,1.759,31.9Zm14.8-.819h-3.7v-3.7h3.7v3.7Zm10.7,0h-3.7v-3.7h3.7ZM14.713,10.761a5.153,5.153,0,0,1,5.456,5.252,5.146,5.146,0,0,1-5.456,5.252,5.153,5.153,0,0,1-5.456-5.252A5.146,5.146,0,0,1,14.713,10.761ZM18.2,20.719a5.844,5.844,0,0,0,0-9.41,20.312,20.312,0,0,1,7.644,4.7A20.263,20.263,0,0,1,18.2,20.719Zm-6.976-9.41a5.844,5.844,0,0,0,0,9.408,20.313,20.313,0,0,1-7.644-4.7A20.313,20.313,0,0,1,11.224,11.309ZM2.168,27.384h3.7v3.7h-3.7Z",
    transform: "translate(-1.349 -9.943)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.074 3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51,12.691a.2.2,0,0,0-.061.283l.611.951A.2.2,0,0,0,7.4,13.7l-.611-.951A.2.2,0,0,0,6.51,12.691Z",
    transform: "translate(-6.416 -12.658)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.146 2.199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.592,9.808a.2.2,0,0,0-.093.274L12,11.1a.2.2,0,1,0,.367-.181l-.5-1.013A.2.2,0,0,0,11.592,9.808Z",
    transform: "translate(-11.478 -9.787)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.31 1.274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9,7.539a.2.2,0,0,0-.122.262l.387,1.062a.2.2,0,1,0,.385-.14l-.386-1.062A.2.2,0,0,0,16.9,7.539Z",
    transform: "translate(-16.765 -7.527)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.544 0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.381,5.884a.2.2,0,0,0-.15.247l.268,1.1a.2.2,0,1,0,.4-.1l-.268-1.1A.2.2,0,0,0,22.381,5.884Z",
    transform: "translate(-22.225 -5.878)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.827 0.174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.98,4.841a.2.2,0,0,0-.176.229l.147,1.12a.2.2,0,0,0,.2.178l.027,0a.2.2,0,0,0,.176-.229l-.147-1.12A.2.2,0,0,0,27.98,4.841Z",
    transform: "translate(-27.802 -4.839)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.644,4.413a.2.2,0,0,0-.2.209l.024,1.13a.2.2,0,0,0,.2.2h0a.2.2,0,0,0,.2-.209l-.024-1.13A.207.207,0,0,0,33.644,4.413Z",
    transform: "translate(-33.444 -4.413)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.352 0.075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.956,4.784l-.1,1.125a.2.2,0,1,0,.408.036l.1-1.125a.2.2,0,0,0-.408-.036Z",
    transform: "translate(-38.857 -4.597)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.526 0.401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.393,5.557l-.22,1.108a.2.2,0,0,0,.4.08l.22-1.108a.2.2,0,0,0-.4-.08Z",
    transform: "translate(-44.169 -5.392)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.663 0.977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.738,6.943,49.4,8.02a.2.2,0,1,0,.39.123l.34-1.078a.2.2,0,1,0-.39-.123Z",
    transform: "translate(-49.389 -6.799)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.741 1.803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.94,8.94l-.456,1.034a.2.2,0,1,0,.375.165L55.315,9.1a.2.2,0,0,0-.375-.165Z",
    transform: "translate(-54.467 -8.818)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.74 2.879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.947,11.548l-.568.977a.2.2,0,0,0,.354.206l.568-.977a.2.2,0,1,0-.354-.206Z",
    transform: "translate(-59.351 -11.446)",
    fill: "#0080ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatavisualization);
export default __webpack_public_path__ + "static/media/datavisualization.06be1e27.svg";
export { ForwardRef as ReactComponent };